export default __webpack_public_path__ + "static/media/gallery_10.09a09067.jpg";